import React, { useEffect } from "react";
import type { NextPage } from "next";

import AnalyticsSender from "../helpers/analyticsSender";

import Meta from "../components/meta/index";
import Header from "../components/header";
import Welcome from "../components/welcome";
import Preview from "../components/previews/previews-containers";
import HowTo from "../components/how-to/index";
import Usage from "../components/usage";
import Footer from "../components/footer/footer-container";
import Popup from "../components/popups/popup";
import canvasActions from "../redux/actions/canvasActions";
import imageActions from "../redux/actions/imageActions";
import Service from "../components/service/service-container";

const Resizer: NextPage = (): JSX.Element => {
  const serviceBtn = React.createRef<HTMLButtonElement>();
  const analyticsSender = new AnalyticsSender();
  const serviceName = "resizer";

  const { image, imageName, imageWidth, imageHeight } = imageActions();

  useEffect(() => {
    analyticsSender.sendShowLandingPage();
  }, []);

  return (
    <>
      <Meta service={serviceName} />
      <main>
        <Header uploadElement={serviceBtn} />
        <Welcome service={serviceName}>
          <Service service={serviceName} uploadElement={serviceBtn}/>
        </Welcome>
        <Preview
          service={serviceName}
          image={image}
          imageName={imageName}
          width={imageWidth}
          height={imageHeight }
          uploadElement={serviceBtn}
          showDescription={true}
        />
        <HowTo service={serviceName} />
        <Usage service={serviceName} />
        <Footer />
        <Popup service={serviceName} />
      </main>
    </>
  );
};

export default Resizer;
